import { Controller } from "@hotwired/stimulus"

// Generic slide-out drawer: overlay + right panel + lazy turbo-frame
// content that reloads on every open. Layered over the page but BELOW
// the global player (deliberately not a modal <dialog> — the top layer
// would cover the player bar and block playback controls). Click-off,
// the X, and Escape all close it. The opening event is bound in markup
// (e.g. library-drawer:toggle@document->drawer#toggle), so any surface
// can host its own drawer.
export default class extends Controller {
  static targets = ["overlay", "panel", "frame"]

  declare readonly overlayTarget: HTMLElement
  declare readonly panelTarget: HTMLElement
  declare readonly frameTarget: HTMLElement & {
    src: string | null
    reload(): Promise<void>
  }

  toggle() {
    if (this.isOpen) {
      this.close()
    } else {
      this.open()
    }
  }

  open() {
    this.refreshContent()
    this.overlayTarget.classList.remove("hidden")
    this.panelTarget.classList.remove("translate-x-full")
    this.panelTarget.setAttribute("data-open", "true")
  }

  close() {
    this.overlayTarget.classList.add("hidden")
    this.panelTarget.classList.add("translate-x-full")
    this.panelTarget.removeAttribute("data-open")
  }

  private get isOpen(): boolean {
    return this.panelTarget.hasAttribute("data-open")
  }

  private refreshContent() {
    const src = this.frameTarget.dataset.src
    if (!src) return

    if (this.frameTarget.src) {
      // Reset to the drawer root (the user may have navigated into a
      // collection last time) and refetch.
      if (this.frameTarget.src.endsWith(src)) {
        void this.frameTarget.reload()
      } else {
        this.frameTarget.src = src
      }
    } else {
      this.frameTarget.src = src
    }
  }
}
